/**
 * src/api/adminPanel.js
 * Vistas de detalle del panel de control global (drill-down del Dashboard).
 */
import api from './client'

export const getActividad = (dias = 7) =>
  api.get('/admin/panel/actividad', { params: { dias } }).then(r => r.data)

export const getActividadDia = (fecha) =>
  api.get('/admin/panel/actividad/dia', { params: { fecha } }).then(r => r.data)

export const getFamilias = () =>
  api.get('/admin/panel/familias').then(r => r.data)

export const getSchedulerDetalle = () =>
  api.get('/admin/panel/scheduler').then(r => r.data)

export const getAlertas = (params = {}) =>
  api.get('/admin/panel/alertas', { params }).then(r => r.data)

export const getEmbudo = (dias = 30) =>
  api.get('/admin/panel/embudo', { params: { dias } }).then(r => r.data)

export const getUso = (dias = 30) =>
  api.get('/admin/panel/uso', { params: { dias } }).then(r => r.data)

export const getUsoAgregado = (dias = 30) =>
  api.get('/admin/panel/uso/agregado', { params: { dias } }).then(r => r.data)

export const getUsoCliente = (clienteId, dias = 30) =>
  api.get(`/admin/panel/uso/cliente/${clienteId}`, { params: { dias } }).then(r => r.data)

export const getUsoHorarios = (dias = 30) =>
  api.get('/admin/panel/uso/horarios', { params: { dias } }).then(r => r.data)
